// @ts-check
// src/stores/orders.js — Faza E.2 + Sesja 3.3 — Orders state in Nanostores
//
// Atomy zastępują pojedyncze pola z window.__sbState.
// Bridge w _legacy-bridge.js synchronizuje obie strony (window ↔ store).
//
// Dla NEW kodu: importuj `$ordersFilters` itp. zamiast pisać `state.ordersFilters`.
// Dla LEGACY kodu: nadal działa `window.__sbState.ordersFilters` (bridge).

import { atom, computed } from 'nanostores';

// ── ORDERS LIST STATE ──────────────────────────────────────────────────

/** Filtry listy zamówień: status / source / payment / search (legacy compound atom) */
export const $ordersFilters = atom({
  status: 'all',
  source: 'all',
  payment: 'all',
  search: '',
});

/** Tryb wyświetlania: 'cards' | 'table' */
export const $ordersViewMode = atom('cards');

/** Czy lista została pobrana z API (po loginie) */
export const $ordersHydrated = atom(false);

/** Czy aktualnie trwa pobieranie */
export const $ordersHydrating = atom(false);

/** Currently selected (clicked) order id — dla nawigacji do detail */
export const $selectedOrderId = atom(/** @type {string | null} */ (null));

/** IDs wybrane checkboxem do bulk actions */
export const $ordersSelectedIds = atom(/** @type {Set<string>} */ (new Set()));

/** Computed: czy są jakieś IDs wybrane */
export const $$hasSelection = computed($ordersSelectedIds, (ids) => ids.size > 0);

/** Computed: count wybranych */
export const $$selectionCount = computed($ordersSelectedIds, (ids) => ids.size);

// ── Sesja 3.3 — additional individual filter/UI atoms ──────────────────

/** Filtr pojedynczego statusu zamówienia ('all' | konkretny status) */
export const $ordersStatusFilter = atom('all');

/** Filtr źródła (allegro / shop / manual / all) */
export const $ordersSourceFilter = atom('all');

/** Filtr statusu płatności */
export const $ordersPaymentFilter = atom('all');

/** Filtr statusu wysyłki */
export const $ordersShipmentFilter = atom('all');

/** Czy grupować w widoku kart po dacie */
export const $ordersGroupByDate = atom(true);

/** Tryb wyboru wielu zamówień (checkboxy widoczne) */
// 2026-08-10: checkboxy sa aktywne od razu — nie ma juz trybu wybierania.
// Default MUSI byc zgodny z `legacy-state.ts`, bo bridge synchronizuje oba w obie strony;
// rozjazd dawalby stan zalezny od tego, ktora strona zapisala jako ostatnia.
export const $ordersSelectMode = atom(true);

/** Czy panel filtrów statusów po lewej widoczny */
export const $ordersPanelVisible = atom(true);

/** Czy drawer szczegółów zamówienia otwarty */
export const $ordersDrawerOpen = atom(false);

/** ID zamówienia w drawer */
export const $ordersDrawerOrderId = atom(/** @type {string | null} */ (null));

// ── DEBUG / DEVTOOLS ───────────────────────────────────────────────────

if (typeof window !== 'undefined') {
  window.__sbStores = Object.assign(window.__sbStores || {}, {
    $ordersFilters,
    $ordersViewMode,
    $ordersHydrated,
    $ordersHydrating,
    $selectedOrderId,
    $ordersSelectedIds,
    $$hasSelection,
    $$selectionCount,
    $ordersStatusFilter,
    $ordersSourceFilter,
    $ordersPaymentFilter,
    $ordersShipmentFilter,
    $ordersGroupByDate,
    $ordersSelectMode,
    $ordersPanelVisible,
    $ordersDrawerOpen,
    $ordersDrawerOrderId,
  });
}
